import { useContext } from 'react'
import swal from 'sweetalert2'

import {
  deepSetObject, digObject, generateRedirectUrl, toggleArray,
} from '@domain-group/javascript-utils'
import type { HandleCallbackActionParams } from '@domain-group/javascript-utils'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import useBrand, { useBrandForm } from '@hooks/useBrand'
import { generateUrls } from '@hooks/useUser'

import type { BrandModel, UserModel } from '@models/types'

type UnassignTemplateDeveloperParams = {
  brandFormPayload: ReturnType<typeof useBrandForm>,
  callbacks: {
    updateBrand: (payload: HandleCallbackActionParams) => Promise<object>,
    updateFn: () => void,
  },
  userId: number,
}

const unassignTemplateDeveloper = (params: UnassignTemplateDeveloperParams) => {
  const {
    brandFormPayload,
    callbacks: {
      updateBrand,
      updateFn,
    },
    userId,
  } = params

  const { entityState } = brandFormPayload

  const templateDeveloperIds = digObject(entityState, 'options.template_developer_user_ids', [])
  const updatedTemplateDeveloperIds = toggleArray(templateDeveloperIds, userId)
  // @ts-expect-error TS2345
  const updatedOptions = deepSetObject(entityState.options, 'template_developer_user_ids', updatedTemplateDeveloperIds)

  const updateBrandPayload = {
    callbacks: {
      action: updateFn,
    },
    entityParams: { options: updatedOptions },
    toastText: 'Template Developer Removed',
  }

  // @ts-expect-error TS2345
  updateBrand(updateBrandPayload)
}

const confirmDelete = (params: UnassignTemplateDeveloperParams) => {
  swal
    .fire({
      confirmButtonColor: '#DD6B55',
      confirmButtonText: 'Yes, unassign them.',
      icon: 'warning',
      showCancelButton: true,
      text: 'Are you sure?',
      title: 'Remove Template Developer?',
    })
    .then(({ value }) => {
      if (value){
        unassignTemplateDeveloper(params)
      }
    })
}

interface ListItemProps {
  brand: BrandModel,
  user: UserModel,
}

const BrandTemplateDeveloperListItem = (props: ListItemProps) => {
  const {
    brand,
    user: {
      id: userId,
      full_name,
    },
  } = props

  const { editUserUrl } = generateUrls({ id: userId })

  const pageContext = useContext(PageContext)
  const {
    callbacks: {
      updateBrand,
    },
  } = pageContext

  const {
    callbacks: {
      updateBrand: updateFn,
    },
  } = useBrand(brand)

  const brandFormPayload = useBrandForm(brand)

  return (
    <DashboardModuleListItem
      title={full_name}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.Actions>
        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          onClick={() => confirmDelete({
            brandFormPayload,
            callbacks: {
              updateBrand,
              // @ts-expect-error TS2322
              updateFn,
            },
            userId,
          })}
          marginRight="medium"
          type="delete"
        />

        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          href={`${editUserUrl}?redirect=${generateRedirectUrl()}`}
          type="link"
        />
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

export default BrandTemplateDeveloperListItem
